import { FC, ReactNode } from 'react';

import { DropdownMenuSubTrigger } from '@savgroup-front-common/primitive/ui/dropdown-menu';

import { MenuRowContent } from '../../../MenuRowContent/MenuRowContent';

interface HeaderProfileMenuSubTriggerProps {
  icon: ReactNode;
  dataTestId?: string;
  children: ReactNode;
}

export const HeaderProfileMenuSubTrigger: FC<
  HeaderProfileMenuSubTriggerProps
> = ({ icon, dataTestId, children }) => {
  return (
    <DropdownMenuSubTrigger data-testid={dataTestId}>
      <MenuRowContent icon={icon}>{children}</MenuRowContent>
    </DropdownMenuSubTrigger>
  );
};
